import {Overlay, OverlayConfig, OverlayRef} from '@angular/cdk/overlay';
import {ComponentPortal} from '@angular/cdk/portal';
import {Component, Injectable} from '@angular/core';
import {ConfirmModalComponent} from '../modals/confirm-modal/confirm-modal.component';

/**
 * @todo update
 */
@Injectable()
export class CdkModalService {
    private overlayRef: OverlayRef;
    componentPortal: ComponentPortal<any>;

    private defaultOverlayConfig: OverlayConfig = {
        hasBackdrop: true,
        backdropClass: 'modal-backdrop-dark',
        disposeOnNavigation: true,
        scrollStrategy: this.overlay.scrollStrategies.block(),
        positionStrategy: this.overlay.position().global().centerHorizontally().centerVertically(),
    };

    constructor(
        private overlay: Overlay,
    ) {
    }

    // tslint:disable-next-line:typedef
    initModal(component = ConfirmModalComponent, data?: object, panelClass: string = 'modal-confirm', config?: OverlayConfig): void {
        this.overlayRef = this.overlay.create({
            ...this.defaultOverlayConfig,
            panelClass,
            ...config,
        });

        this.componentPortal = new ComponentPortal(component);

        if (!this.overlayRef.hasAttached()) {
            this.overlayRef.attach(this.componentPortal);
        }
    }
}
